import React, { Component } from "react";

import Sunset from "../components/Sunset";

import "../styles/Tour.css";

export default class Tour extends Component {
    componentDidMount() {
        const script = document.createElement("script");
        script.src = "https://widget.bandsintown.com/main.min.js";
        document.body.appendChild(script);
    }

    render() {
        return (
            <div>
                <Sunset />
                <div className="tour-dates">
                    <script src="https://widget.bandsintown.com/main.min.js" />
                    <div
                        className="bit-widget-initializer"
                        data-artist-name="Professor Jones"
                        data-display-local-dates="false"
                        data-display-past-dates="true"
                        data-auto-style="false"
                        data-text-color="#FFFFFF"
                        data-link-color="#F1C200"
                        data-popup-background-color="rgba(0,0,0,0)"
                        data-background-color="rgba(0,0,0,0)"
                        data-link-text-color="#FFFFFF"
                        data-display-limit=""
                    ></div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Tour.js